export type SearchOrigin = 'scenario' | 'payment-preference';

function searchOriginKey(clientId: string): string {
  return `consumer-search-from-payment-preference:${clientId}`;
}

/**
 * The quote search starts from the care scenario, or from How you'd like to pay for a consumer who
 * came over from the self-funding projection. Remembered for the browser session, so Back from the
 * options returns to whichever screen started it, even after a reload.
 */
export function rememberSearchOrigin(clientId: string, origin: SearchOrigin) {
  try {
    if (origin === 'payment-preference') sessionStorage.setItem(searchOriginKey(clientId), 'true');
    else sessionStorage.removeItem(searchOriginKey(clientId));
  } catch {
    // Storage can be unavailable (private browsing); Back from the options then goes to the scenario.
  }
}

export function searchOrigin(clientId: string): SearchOrigin {
  try {
    return sessionStorage.getItem(searchOriginKey(clientId)) === 'true' ? 'payment-preference' : 'scenario';
  } catch {
    return 'scenario';
  }
}
